<template>
  <div class="top-lists">
    <div class="top-lists.container">
      <div
        class="top-lists.view"
        v-for="(item, indx) in topData"
        :key="indx"
        @click="goCaseDetail(item)"
        data-aos="zoom-in-up"
      >
        <div class="top-lists.view.front">
          <div class="top-lists.view.logo">
            <img :src="item.icon" alt=""/>
          </div>
          <div class="top-lists.view.icon">
            <img src="../assets/case/top-common.png" alt="" />
          </div>
          <h4>{{ item.name }}</h4>
          <div class=""></div>
        </div>
        <div class="top-lists.view.mask">
          <div class="top-lists.view.logo-aos">
            <img src="../assets/case/top-common.png" alt="" />
          </div>
          <h2>{{ item.name }}</h2>
          <p>{{ item.desc }}</p>
          <a href="javascript:;">查看详情</a>
        </div>
      </div>
    </div>
    <div class="top-lists.page" v-show="pageParams.totalMCount > 18">
      <el-pagination
        background
        layout="prev, pager, next"
        :hide-on-single-page="true"
        @size-change="handleMChange"
        @current-change="handleMCurrentChange"
        :current-page.sync="pageParams.pageMNo"
        :page-size="18"
        :total="pageParams.totalMCount"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  props: ["pageParams", "topLists"],
  data() {
    return {
      // topLists: [{
      // 		name: 'SEBE 拾贝',
      // 		desc: '国家鼓励研究开发机构、高等院校通过转让、许可或者作价投资等方式',
      // 		id:0,
      // 	}]
    };
  },
  methods: {
    goCaseDetail(row) {
      //this.$router.push(this.$route.path + '/' +row.id)
      let routeUrl = this.$router.resolve({
        path: this.$route.path + "/" + row.id,
      });
      window.open(
        location.pathname + "#" + routeUrl.resolved.fullPath,
        "_blank"
      ); //线上发布用
    },
    getPageMData() {
      this.$emit("updateLists", this.pageParams.pageMNo);
    },
    handleMChange(val) {
      this.$nextTick(() => {
        this.getPageMData();
      });
    },
    handleMCurrentChange(val) {
      this.getPageMData();
    },
  },
  computed: {
    topData() {
      return this.topLists.map(
        ({ name, image, illustration_image, id, synopsis }) => {
          return {
            name: name,
            desc: synopsis,
            id: id,
            icon: this.imgUrl + image,
          };
        }
      );
    },
  },
};
</script>

<style lang="scss">
@keyframes bounceY {
  0% {
    transform: translateY(-205px);
  }

  40% {
    transform: translateY(-100px);
  }

  65% {
    transform: translateY(-52px);
  }

  82% {
    transform: translateY(-25px);
  }

  92% {
    transform: translateY(-12px);
  }

  55%,
  75%,
  87%,
  97%,
  100% {
    transform: translateY(0px);
  }
}

@include component(top-lists) {
  width: 100%;
  color: #333333;
  margin-top: 10px;

  @include part(container) {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
  }

  @include part(view) {
    width: 226px;
    height: 270px;
    background: rgba(255, 255, 255, 1);
    border: 3px solid transparent;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
    padding: 18px 28px;
    overflow: hidden;
    position: relative;
    cursor: pointer;

    &:not(:nth-child(5n)) {
      margin-right: 17px;
    }

    &:nth-child(n + 6) {
      margin-top: 10px;
    }

    @include part(logo) {
      width: 100%;
      height: 78px;
      img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: contain;
        object-position: center;
      }
    }

    @include part(icon) {
      margin-top: 31px;
      position: relative;

      &:before {
        content: "";
        display: inline-block;
        width: 63px;
        height: 1px;
        background: #f2f2f2;
        position: absolute;
        left: 0;
        top: 30px;
      }

      &:after {
        content: "";
        display: inline-block;
        width: 63px;
        height: 1px;
        background: #f2f2f2;
        position: absolute;
        right: 0;
        top: 30px;
      }
    }

    h4 {
      font-size: 18px;
	   overflow: hidden;
	  text-overflow: ellipsis;
	  white-space: nowrap;
	 
    }

    @include part(mask) {
      width: 100%;
      height: 100%;
      position: absolute;
      overflow: hidden;
      top: 0;
      left: 0;
      background-color: rgba(255, 255, 255, 1);
      top: -270px;
      filter: alpha(opacity=0);
      opacity: 1;
      transition: all 0.3s ease-out 0.5s;
    }

    @include part(logo-aos) {
      margin-top: 18px;
      transform: translateY(-270px);
      transition: all 0.2s ease-in-out 0.1s;
    }

    h2 {
      margin: 0;
      font-size: 18px;
      margin-top: 10px;
      transform: translateY(-270px);
      transition: all 0.2s ease-in-out 0.1s;
	  color: red;
	  overflow: hidden;
	  text-overflow: ellipsis;
	  white-space: nowrap;
	  padding: 0 30px;
    }

    p {
      font-size: 16px;
      text-align: left;
      color: #999999;
      padding: 0 20px;
      margin: 10px 0;
      line-height: 24px;
      transform: translateY(-270px);
      transition: all 0.2s ease-in-out 0.2s;
      text-align: center;
      height: 70px;
      overflow: hidden;
    }

    a {
      display: inline-block;
      width: 160px;
      height: 32px;
      line-height: 32px;
      color: #ffffff;
      background: rgba(244, 114, 39, 1);
      border-radius: 2px;
      margin: 0 auto;
      font-size: 14px;
      transform: translateY(-270px);
      transition: all 0.2s ease-in-out 0.3s;
      margin-top: 10px;
      text-align: center;
    }

    &:hover {
      border-color: #f47227;

      @include part(mask) {
        filter: alpha(opacity=100);
        opacity: 1;
        top: 0px;
        transition-delay: 0s;
        animation: bounceY 0.9s linear;
      }
      @include part(front) {
        opacity: 0;
      }

      @include part(logo-aos) {
        transform: translateY(0px);
        transition-delay: 0.6s;
      }

      h2 {
        transform: translateY(0px);
        transition-delay: 0.4s;
      }

      p {
        transform: translateY(0px);
        transition-delay: 0.2s;
      }

      a {
        transform: translateY(0px);
        transition-delay: 0s;
      }
    }
  }
  @include part(page) {
    width: 100%;
    height: 80px;
    background: #fff;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 10px;
  }
}
</style>
